module.exports = __webpack_public_path__ + "img/Slipmat Gold.b9cc5af7.png";